// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1uTco","content":"styles_content__21oKk","checkbox":"styles_checkbox__2aD7-","checkboxLabel":"styles_checkboxLabel__3U-Xs"};